import { useMutation, useQueryClient } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { sendToApi } from 'api/client'
import { UseMutationOptions } from 'react-query/types/react/types'
import { BrandProfile } from 'types'

interface Props {
  id: number
}

type Data = BrandProfile[]

export type Options = Omit<UseMutationOptions<Data>, 'mutationKey' | 'mutationFn'>

export const deleteBrandProfile = (id: number, workspaceId: number) =>
  sendToApi(`/w/${workspaceId}/brand_profiles/${id}`, { method: 'DELETE' })

export const useDeleteBrandProfile = ({ id }: Props, options?: Options) => {
  const queryClient = useQueryClient()
  const currentWorkspaceId = useCurrentWorkspaceId()
  return useMutation(
    ['workspaces', currentWorkspaceId, 'brandProfiles', id],
    async () => {
      const response = await deleteBrandProfile(id, currentWorkspaceId)
      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error()
      }
      return response.data
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(['workspaces', currentWorkspaceId, 'brandProfiles', 'list'])
        options?.onSuccess?.(data, variables, context)
      },
    },
  )
}
